import React from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PendingActionsIcon from '@mui/icons-material/PendingActions';

export default function PRToolbar({ issuesCount = 0, fixedCount = 0, intentionalCount = 0, stagedCount = 0, onDiscardAll, onCommitAll, commitDisabled = false, committing = false, leftAdornment = null, rightAdornment = null, height = 48, sticked = false, layout = {} }) {
  return (
    <Box sx={{ height, backgroundColor: '#0d1117', border: '1px solid #30363d', px: 2, display: 'flex', alignItems: 'center', gap: 2, borderRadius: '6px', zIndex: 2000, position: sticked ? 'fixed' : 'relative', ...layout }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#c9d1d9', fontWeight: 600, flex: 1 }}>
        {leftAdornment}
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, mr: 1.5 }}>
          <ErrorOutlineIcon fontSize="small" sx={{ color: '#d29922' }} />
          <Typography variant="body2" sx={{ color: '#c9d1d9' }}>Issues</Typography>
          <Chip label={issuesCount} size="small" sx={{ ml: 0.5, backgroundColor: '#21262d', color: '#f0f6fc', height: 22 }} />
        </Box>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, mr: 1.5 }}>
          <CheckCircleOutlineIcon fontSize="small" sx={{ color: '#3fb950' }} />
          <Typography variant="body2" sx={{ color: '#c9d1d9' }}>Fixed</Typography>
          <Chip label={fixedCount} size="small" sx={{ ml: 0.5, backgroundColor: '#21262d', color: '#f0f6fc', height: 22 }} />
        </Box>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, mr: 1.5 }}>
          <Typography variant="body2" sx={{ color: '#c9d1d9' }}>Intentional</Typography>
          <Chip label={intentionalCount} size="small" sx={{ ml: 0.5, backgroundColor: '#21262d', color: '#ffa657', height: 22 }} />
        </Box>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <PendingActionsIcon fontSize="small" sx={{ color: '#58a6ff' }} />
          <Typography variant="body2" sx={{ color: '#c9d1d9' }}>Changes to commit</Typography>
          <Chip label={stagedCount} size="small" sx={{ ml: 0.5, backgroundColor: '#21262d', color: '#f0f6fc', height: 22 }} />
        </Box>
      </Box>
      <Button onClick={onDiscardAll} sx={{ color: '#f85149', '&:hover': { backgroundColor: '#f8514920' } }}>Discard</Button>
      <Button onClick={onCommitAll} variant="contained" disabled={commitDisabled} size="small" sx={{ backgroundColor: commitDisabled ? '#2a2f36' : '#3fb950', color: commitDisabled ? '#c9d1d9' : '#0d1117', '&:hover': { backgroundColor: commitDisabled ? '#2a2f36' : '#2ea043' }, '&.Mui-disabled': { backgroundColor: '#2a2f36', color: '#c9d1d9', opacity: 1, border: '1px solid #30363d' }, minHeight: 24, height: 28, py: 0.25, px: 1.5, alignSelf: 'center', borderRadius: '8px', fontSize: '0.8125rem' }}>{committing ? 'Committing…' : 'Commit'}</Button>
      {rightAdornment}
    </Box>
  );
}




